import { $api } from "@/kibi/core/utils/api";
import type { InjectionKey } from "vue";
import type {
  Category,
  CreateCategoryRequest,
  UpdateCategoryRequest,
} from "../../domain/entities/category";

export interface CategoryDataSource {
  getCategories(): Promise<Category[]>;
  getCategory(id: string): Promise<Category>;
  createCategory(request: CreateCategoryRequest): Promise<Category>;
  updateCategory(id: string, request: UpdateCategoryRequest): Promise<Category>;
  deleteCategory(id: string): Promise<void>;
}

export const categoryDataSourceKey: InjectionKey<CategoryDataSource> =
  Symbol("CategoryDataSource");

export class CategoryDataSourceImpl implements CategoryDataSource {
  async getCategories(): Promise<Category[]> {
    const response = await $api<{ data: Category[] }>("/products/categories", {
      method: "GET",
    });
    return response.data;
  }

  async getCategory(id: string): Promise<Category> {
    const response = await $api<{ data: Category }>(
      `/products/categories/${id}`,
      {
        method: "GET",
      },
    );
    return response.data;
  }

  async createCategory(request: CreateCategoryRequest): Promise<Category> {
    const response = await $api<{ data: Category }>("/products/categories", {
      method: "POST",
      body: request,
    });
    return response.data;
  }

  async updateCategory(
    id: string,
    request: UpdateCategoryRequest,
  ): Promise<Category> {
    const response = await $api<{ data: Category }>(
      `/products/categories/${id}`,
      {
        method: "PUT",
        body: request,
      },
    );
    return response.data;
  }

  async deleteCategory(id: string): Promise<void> {
    await $api(`/products/categories/${id}`, {
      method: "DELETE",
    });
  }
}
